module.exports = __webpack_public_path__ + "static/media/wizualizacja-90.d697d12c.png";